import { Link } from "react-router";
import { CompassIcon } from "lucide-react";

import { EmptyState } from "@/components/page-header";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<CompassIcon />}
      title="No such page"
      description="The URL does not match any screen in the admin UI."
      action={
        <Button asChild variant="outline" size="sm">
          <Link to="/accounts">Back to accounts</Link>
        </Button>
      }
    />
  );
}
